<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.03.13</b> - Somewhat Big AI Fix</p>
    <div class="ml-5 pb-4 text-blue-500">
      <div class="font-bold mt-2">Battle AI</div>
      <ul class="ml-4 list-disc">
        <li>
          All AI decision tres now check if units have the AP/MP to use abilities (considering
          Adrenaline / Mystic Focus) before selecting them, and default to other abilities or tree
          nodes before starting the next tree. This is a significant change (previously they would
          just select abilities with no consideration of AP/MP costs), so let me know if you spot
          any new issues. You may want to recalibrate some of your squads to take advantage of the
          improved logic.
        </li>
      </ul>

      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>Trying to swap equipped bags with non-bag items is handle now.</li>
        <li>Fixed error handling when attempting to enter Caverns without sufficient gold</li>
      </ul>
    </div>
  </div>
</template>
